/**
 * 获取路径上的参数
 * @param {*} url 
 */
export function getUrlQuery(url) {
  const index = url.indexOf('?');
  if (index === -1) return {};
  const queryList = url.substr(index + 1).split('&');
  return queryList.reduce((result, curr) => {
    const [key, value] = curr.split('=');
    return { ...result, [key]: value };
  }, {});
}



// WEBPACK FOOTER //
// ./src/utils/index.js